import { Action } from 'redux';
import { PlanDetailsActiveTab } from '../../interfaces/product.interface';

export const PLAN_DETAILS_ACTIVE_TAB_REDUCER_NAME = 'PlanDetailsActiveTab';
/** INITIAL STATE */
const INITIAL_STATE: PlanDetailsActiveTab = {
  activeTab: 'DETAILS'
};

/** ACTION TYPES */
const UPDATE_ACTIVE_TAB = 'UPDATE_ACTIVE_TAB';

/** ACTION INTERFACE - which implements Redux's ACTION */
export class PlanDetailsActiveTabAction implements Action {
  type: string;
  activeTab: string;
}

/** ACTIONS */
export function updateActiveTab(
  activeTab: string
): PlanDetailsActiveTabAction {
  return { type: UPDATE_ACTIVE_TAB, activeTab };
}

export function PlanDetailsActiveTab(
  state = INITIAL_STATE,
  action: PlanDetailsActiveTabAction
) {
  const copiedState = JSON.parse(JSON.stringify(Object.assign({}, state)));

  switch (action.type) {
    case UPDATE_ACTIVE_TAB:
      /** Save Comparable Plan Ids */
      copiedState.activeTab = action.activeTab;
      return Object.assign({}, state, copiedState);
    default:
      return state;
  }
}
